import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Alert, Spinner } from 'react-bootstrap';

const ConfirmarAccionModal = ({
    show,
    onHide,
    accionSeleccionada,
    onConfirm,
    loading,
    error
}) => {
    const getAccionText = (accion) => {
        switch (accion) {
            case 'aprobar':
                return 'aprobar';
            case 'rechazar':
                return 'rechazar';
            case 'cancelar':
                return 'cancelar';
            default:
                return accion;
        }
    };

    const getAccionInfo = (accion) => {
        switch (accion) {
            case 'aprobar':
                return {
                    title: 'Aprobar Asignación',
                    message: '¿Estás seguro de que quieres aprobar esta asignación?',
                    variant: 'success'
                };
            case 'rechazar':
                return {
                    title: 'Rechazar Asignación',
                    message: '¿Estás seguro de que quieres rechazar esta asignación?',
                    variant: 'danger'
                };
            case 'cancelar':
                return {
                    title: 'Cancelar Asignación',
                    message: '¿Estás seguro de que quieres cancelar esta asignación?',
                    variant: 'warning'
                };
            default:
                return {
                    title: 'Confirmar acción',
                    message: `¿Estás seguro de que quieres ${getAccionText(accion)} la asignación seleccionada?`,
                    variant: 'primary'
                };
        }
    };

    const accionInfo = accionSeleccionada ? getAccionInfo(accionSeleccionada.accion) : null;

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{accionInfo?.title || 'Confirmar acción'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {accionSeleccionada && (
                    <>
                        <p>{accionInfo?.message}</p>
                        {accionSeleccionada.asignacion && (
                            <div className="bg-light p-3 rounded">
                                <small className="text-muted">Asignación:</small>
                                <div>
                                    <strong>Conductor:</strong> {accionSeleccionada.asignacion.usuario_movil?.usuarioSpread || 'N/A'}
                                </div>
                                <div>
                                    <strong>Extra:</strong> {accionSeleccionada.asignacion.extra?.extra || 'N/A'}
                                </div>
                                <div>
                                    <strong>Monto:</strong> ${accionSeleccionada.asignacion.monto || 0}
                                </div>
                                <div>
                                    <strong>Total:</strong> ${(accionSeleccionada.asignacion.monto || 0) * (accionSeleccionada.asignacion.cantidad || 0)}
                                </div>
                            </div>
                        )}
                        {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={loading}>
                    Cancelar
                </Button>
                <Button 
                    variant={accionInfo?.variant || 'primary'} 
                    onClick={onConfirm} 
                    disabled={loading}
                >
                    {loading ? <Spinner size="sm" animation="border" /> : 'Confirmar'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ConfirmarAccionModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    accionSeleccionada: PropTypes.shape({
        asignacion: PropTypes.object,
        accion: PropTypes.string
    }),
    onConfirm: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string
};

export default ConfirmarAccionModal;
